/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Type_Email_AssigneeInputs */

const en_task_catalog_type_email_assignee = /** @type {(inputs: Task_Catalog_Type_Email_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emails the assignee when assigned`)
};

const pt_br2_task_catalog_type_email_assignee = /** @type {(inputs: Task_Catalog_Type_Email_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envia e-mail ao responsável quando atribuída`)
};

/**
* | output |
* | --- |
* | "Emails the assignee when assigned" |
*
* @param {Task_Catalog_Type_Email_AssigneeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_type_email_assignee = /** @type {((inputs?: Task_Catalog_Type_Email_AssigneeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Type_Email_AssigneeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_type_email_assignee(inputs)
	return pt_br2_task_catalog_type_email_assignee(inputs)
});